import React from "react";
import { NavLink } from "react-router-dom";

const Link = ({ href, label, onClose, Icon }) =>  {
    return (
        <NavLink
            to={href}
            onClick={onClose}
            className={({ isActive }) => `
                group flex justify-between min-h-8 transition-colors duration-300 ease-in-out text-sm
                ${isActive ? " text-white bg-rs-rojo animate-pulse" : "text-white bg-rs-azul hover:bg-black"}
                focus:outline-none focus-visible:ring-2 focus-visible:ring-red-400
                px-2 py-2 m-2 rounded-md`}
        >
            {label}{Icon && <Icon className="text-white transition-transform duration-300 group-hover:scale-110" size={20} />}
        </NavLink>
    )
};

export default Link;